<template>
  <div class="mod-resetpwd">
    <mini-header :headerTitle="'重置密码'"></mini-header>
    <div class="reset-main">
      <div class="mod-title">
        <h1>重置密码</h1>
        <span class="under-line"></span>
      </div>
      <div class="form_panel">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <input type="password" hidden autocomplete="new-password" />
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
          </el-form-item>
          <el-row :gutter="18">
            <el-col :span="15">
              <el-form-item label="验证码" prop="captcha_phone">
                <el-input v-model="ruleForm.captcha_phone" maxlength="6"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <div class="getcaptcha" @click="getCaptchaHandle">
                <span v-show="showCaptcha">获取验证码</span>
                <span v-show="!showCaptcha">{{ count }}s后重新发送</span>
              </div>
            </el-col>
          </el-row>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="comfirmPassword">
            <el-input type="password" v-model="ruleForm.comfirmPassword" maxlength="16"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 37px;text-align: center;">
            <el-button class="subbtn" round @click="$router.back(-1)">返回</el-button>
            <el-button type="primary" class="subbtn" round @click="submitForm">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import { isMobile } from "@/utils/validate";
import { RSAEncrypt } from "@/utils";
import MiniHeader from "./../common/mini-header.vue";
import MainFooter from "./../main-footer.vue";
export default {
  components: {
    MiniHeader,
    MainFooter,
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      // const reg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/;
       const reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,16}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value)) {
          callback(new Error("必须由字母、数字组成，区分大小写，6到16位"));
        } else {
          callback();
        }
      }
    };
    var validateComfirmPassword = (rule, value, callback) => {
      if (!/\S/.test(value)) {
        callback(new Error("确认密码不能为空"));
      } else if (this.ruleForm.password !== value) {
        callback(new Error("确认密码与密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        phone: "",
        captcha_phone: "",
        password: "",
        comfirmPassword: "",
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" }
        ],
        captcha_phone: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" }
        ],
        comfirmPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validateComfirmPassword, trigger: "blur" }
        ],
      },
      showCaptcha: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    // 获取验证码基于手机号
    getCaptchaHandle() {
      if(!this.showCaptcha)return
      this.$refs["ruleForm"].validateField("phone", (valid) => {
        if (!valid) {
          let params = {
            phone: this.ruleForm.phone
          };
          this.$http.post(this.$api.shiroApi.sendCaptchaByPhone, params).then(({ data }) => {
            if (data.code === 200) {
              this.countdown(60);
            }
          });
        }
      });
    },
    // 表单提交
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            phone: this.ruleForm.phone,
            captchaPhone: this.ruleForm.captcha_phone,
            password: RSAEncrypt(this.ruleForm.password)
          };
          this.$http.post(this.$api.shiroApi.resetPw, params).then(({ data }) => {
            if (data.code === 200) {
              this.$message({
                message: "重置密码成功！",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.$router.replace({ name: "login" });
                },
              });
            }
          });
        }
      });
    },
    // 倒计时
    countdown(second) {
      const TIME_COUNT = second;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCaptcha = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCaptcha = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-resetpwd {
  height: inherit;
  .reset-main {
    width: 1200px;
    margin: 30px auto 50px auto;
    padding: 32px;
    min-height: 500px;
    background: #fff;
    height: calc(100% - 219px);
    .mod-title {
      h1 {
        font-size: 24px;
      }
    }
    .form_panel {
      width: 650px;
      margin: 50px auto;
      .el-form-item {
          margin-bottom: 14px;
      }
      .getcaptcha {
        height: 42px;
        line-height: 42px;
        color: #1460AE;
        border: 1px solid #dcdfe6;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
      }
      .subbtn {
        width: 160px;
        height: 50px;
        border-radius: 30px;
        font-size: 16px;
      }
    }
  }
}
</style>
